module.exports = __webpack_public_path__ + "img/gitazul.68fb1c4c.webp";